/* @sravni/react-header version 0.2.43 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';
import '../../DropdownMenu/index.js';
import { makeRelAttribute } from '../../../utils/links.js';
import { useAnalyticEvents, EVENTS } from '../../../hooks/useAnalyticEvents.js';
import modules_0e839d3f from '../styles/Navigation.module.less.js';
import DropdownMenu from '../../DropdownMenu/src/DropdownMenu.js';

/**
 * @description NavigationItem component.
 *
 * @component
 * @example
 * ```jsx
 * <NavigationItem />
 * ```
 */
var NavigationItem = React.forwardRef(function (props, ref) {
    var config = props.config, control = props.control, clean = props.clean, wide = props.wide, fullscreen = props.fullscreen, visible = props.visible, activeItem = props.activeItem, className = props.className, children = props.children, restProps = __rest(props, ["config", "control", "clean", "wide", "fullscreen", "visible", "activeItem", "className", "children"]);
    var _a = __assign({}, config), text = _a.text, isLink = _a.isLink, href = _a.href, openInNew = _a.openInNew;
    var cx = useStyles(modules_0e839d3f);
    var pushAnalyticEvent = useAnalyticEvents().pushAnalyticEvent;
    var navigationItemClassnames = cx(className, 'item', {
        'item--clean': clean
    });
    var dropdownClassnames = cx({
        dropdownVisible: visible === true || text === activeItem,
        dropdownHidden: visible === false
    });
    var handleTopMenuLinkClick = React.useCallback(function (event) {
        var label = event.currentTarget.dataset.label || '';
        pushAnalyticEvent(EVENTS.MENU_LINK_CLICK, { eventLabel: label + "|\u041F\u0435\u0440\u0435\u0445\u043E\u0434 \u043F\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0443" });
    }, []);
    var menuItem = React.useMemo(function () {
        return isLink ? (React.createElement(Link, { "data-label": text, color: "black", href: href, target: openInNew ? '_blank' : undefined, rel: makeRelAttribute(config), onClick: handleTopMenuLinkClick },
            React.createElement(Text, { className: cx('text'), strong: true }, text))) : (React.createElement(Text, { "data-label": text, className: cx('text'), strong: true }, text));
    }, [config, handleTopMenuLinkClick]);
    return (React.createElement(Space, __assign({ ref: ref, align: "center", className: navigationItemClassnames }, restProps),
        text ? menuItem : null,
        control ? control : null,
        React.createElement(DropdownMenu, { wide: wide, fullscreen: fullscreen, className: dropdownClassnames }, children)));
});
NavigationItem.defaultProps = {
    clean: false,
    wide: false,
    fullscreen: false
};

export { NavigationItem as default };
//# sourceMappingURL=NavigationItem.js.map
